import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=71bde24e&scoped=true&"
import script from "./AddMember.vue?vue&type=script&lang=js&"
export * from "./AddMember.vue?vue&type=script&lang=js&"
import style0 from "./AddMember.vue?vue&type=style&index=0&id=71bde24e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bde24e",
  null
  
)

component.options.__file = "AddMember.vue"
export default component.exports